import { render } from "./sideways.vue?vue&type=template&id=601cece4"
import script from "./sideways.vue?vue&type=script&lang=ts"
export * from "./sideways.vue?vue&type=script&lang=ts"
script.render = render

export default script